import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Input,
  Label,
} from "reactstrap";
import { connect } from "react-redux";
import { setBreadcrumbItems } from "../../store/actions";
import Spinners from "components/Common/Spinner";
import * as url from "../../helpers/url_helper";
import "flatpickr/dist/themes/material_blue.css";
import { MDBDataTable } from "mdbreact";
import { Link, useLocation, useParams } from "react-router-dom";
import { Modal, Button } from "react-bootstrap";
import { toast } from "react-toastify";
import Select from "react-select";
const data = {
  loading: true,
  errors: {},
  ResErrors: {},
  RoleList: [],
  sangathanList: [],
  isRedirect: false,
  sangathanId: null,
  dropdownData: [],
  sangathanName: "",
  selectedSangathan: {
    label: null,
    name: null,
    _id: null,
    parentId: null,
    options: [],
  },
  currentEditItem: {},
  itemLoading: false,
  itemDeleteLoading: false,
  deleteItemId: null,
  moveItemSelected: {},
  isPrepareMove: false,
  isMoving: false,
  moveTargetItem: {},
  token: "Bearer SECRET",
  errors: {},
};
const ChildSangathanList = (props) => {
  document.title = "Sangathan List - VUF";
  const [Values, setValues] = useState(data);
  const { childId } = useParams();
  const [sangathanList, setSangathanList] = useState([]);
  const [sangathanUserList, setSangathanUserList] = useState([]);
  const [editSangathanModal, setEditSangathanModal] = useState(false);
  const [moveSangathanModal, setMoveSangathanModal] = useState(false);
  const [sangathanId, setSangathanId] = useState("");
  const [sangathanName, setSangathanName] = useState("");
  const [newSangathanName, setNewSangathanName] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [addModal, setAddSangathanModal] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [sameSangathan, setSameSangathan] = useState(true);
  const [userId, setUserId] = useState("");
  const [changeRoleModal, setChangeRoleModal] = useState(false);
  const [roleList, setRoleList] = useState([]);
  const [role, setRole] = useState("");
  const [sourceIds, setSourceId] = useState("");
  const [targetIds, setTargetId] = useState("");
  const [targetName, setTargetName] = useState("");

  const breadcrumbItems = [
    { title: "VUF", link: "#" },
    { title: "Child Sangathan List", link: "#" },
  ];

  const [isLoading, setLoading] = useState(false);
  const location = useLocation();
  const hierarchy = location.state?.hierarchy || [];
  const lastRecord = hierarchy[hierarchy.length - 1];

  useEffect(() => {
    props.setBreadcrumbItems("List", breadcrumbItems);
  });
  const ChangeRole = async (id) => {
    setUserId(id);
  };
  useEffect(() => {
    _getUserCred();
    onGetChildSangathanList(childId);
    // Perform your componentDidMount logic here
  }, [childId]);

  const handleEditSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await fetch(
        url.url + `/sangathan/rename-sangathan/${sangathanId}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ _id: sangathanId, name: sangathanName }),
        }
      );

      if (res.ok) {
        toast.success("Sangathan updated successfully");
        setEditSangathanModal(false);
        setSangathanList((prev) =>
          prev.map((item) =>
            item._id === sangathanId
              ? { ...item, name: sangathanName } // update this one
              : item
          )
        );
      } else {
        console.error("Update failed");
      }
    } catch (error) {
      console.error("Error updating Sangathan:", error);
    }
  };
  const onAddSangathan = (e) => {
    setSangathanId(childId);
    setSangathanName(lastRecord.name);
  };
  const handleMoveSubmit = async (e) => {
    e.preventDefault();

    const confirmMove = window.confirm(
      `Move this ${sangathanName} to ${targetName} with its users, You can not undo this action, Are you sure?`
    );

    if (confirmMove) {
      try {
        const res = await fetch(url.url + `/sangathan/move-sangathan`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            sourceId: sourceIds,
            targetId: targetIds,
          }),
        });

        if (res.ok) {
          const updatedData = await res.json();
          toast.success("Sangathan moved successfully");
          setMoveSangathanModal(false);
          setSangathanList((prev) =>
            prev.map((item) =>
              item._id === sourceIds
                ? {
                    ...item,
                    parentId: targetIds,
                    name: updatedData.name || item.name,
                  }
                : item
            )
          );
        } else {
          console.error("Update failed");
        }
      } catch (error) {
        console.error("Error updating Sangathan:", error);
      }
    }
  };
  const handleAddSubmit = async (e) => {
    e.preventDefault();
    const Body = JSON.stringify({
      parentId: childId,
      name: newSangathanName.trim(),
    });
    try {
      const res = await fetch(url.url + `/sangathan/create-sangathan`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: Body,
      });

      if (res.ok) {
        const data = await res.json();
        toast.success("Sangathan added successfully");
        setAddSangathanModal(false);
        setSangathanList((prev) => [...prev, data.response.sangathan]);
      } else {
        console.error("Update failed");
      }
    } catch (error) {
      console.error("Error updating Sangathan:", error);
    }
  };

  function _getUserCred() {
    let user = localStorage.getItem("user");
    user = JSON.parse(user);
    // const User = user;

    const role = localStorage.getItem("role");

    let state = user;
    let sangathanId = state?.sangathanId || "";
    const Role = state.role || "Member";
    setValues((prevState) => ({
      ...prevState,
      user: state,
      role: state.role,
      isMember: !state.role || state.role?.toLowerCase() == "member" || false,
      sangathanId: sangathanId,
      token: localStorage.getItem("token"),
      loading: true,
    }));
    onGetChildSangathanList();
  }
  const handleEditSangathan = (id, name) => {
    setSangathanId(id);
    setSangathanName(name);
    setEditSangathanModal(true);
  };
  const handleMoveSangathan = (id, name) => {
    setSangathanId(id);
    setSangathanName(name);
    setMoveSangathanModal(true);
  };

  const getRolesList = async (e) => {
    let urlPath = "/role/get-roles-list";
    fetch(url.url + urlPath, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then(async (responseData) => {
        if (responseData.status) {
          const roles = responseData.response;
          setRoleList(
            roles.map((item) => ({
              label: item.name,
              value: item._id,
            }))
          );
        } else {
          alert("Something went wrong, Please try again after sometime.");
        }
      })
      .catch((error) => {
        console.log("err", error);
        alert("Something went wrong, Please try again after sometime.");
      })
      .finally((final) => {});
  };
  const handleChangeRole = async (e) => {
    e.preventDefault();
    if (!userId) {
      return toast.warning("User not found");
    }
    try {
      fetch(url.url + `/user/change-role/${userId}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ role: role.label }),
      })
        .then((response) => response.json())
        .then(async (responseData) => {
          toast.success(responseData.message);
          setChangeRoleModal(false);
          setShowModal(true);
          setSangathanUserList((prev) =>
            prev.map((item) =>
              item._id === userId ? { ...item, role: role.label } : item
            )
          );
        });
    } catch (error) {
      console.error("Error updating Sangathan:", error);
    }
  };
  function onGetChildSangathanList(SangathanId = null) {
    setLoading(true);
    const urlPath = SangathanId
      ? `/sangathan/get-sangathan-user-list?sangathanId=${SangathanId}`
      : `/sangathan/get-parent-sangathan-list/${childId}`;

    fetch(url.url + urlPath, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then(async (responseData) => {
        if (responseData.status) {
          if ("sangathanList" in (responseData.response || {})) {
            setSangathanList(responseData.response.sangathanList);
          } else if ("memberList" in (responseData.response || {})) {
            setSangathanUserList(responseData.response.memberList);
          }
        } else {
          console.error("API Error:", responseData.error || "Unknown error");
        }
      })
      .catch((error) => {
        console.log("err", error);
      })
      .finally((final) => {
        setLoading(false);
      });
  }

  // function onGetChildSangathanList() {
  //   setLoading(true);
  //   let urlPath = `/sangathan/get-parent-sangathan-list/${childId}`;

  //   fetch(url.url + urlPath, {
  //     method: "GET",
  //     headers: {
  //       Accept: "application/json",
  //       "Content-Type": "application/json",
  //       Authorization: Values.token,
  //     },
  //     // body: Body,
  //   })
  //     .then((response) => response.json())
  //     .then(async (responseData) => {
  //       if (responseData.status && "response" in responseData) {
  //         setSangathanList(responseData?.response?.sangathanList || []);
  //       } else if (!responseData.status && "auth" in responseData) {
  //         // AuthController.Logout();
  //       } else if (!responseData.status && responseData.error) {
  //         console.log("Something went wrong");
  //       } else {
  //         console.log("Something went wrong");
  //       }
  //       setLoading(false);
  //     })
  //     .catch((error) => {
  //       console.log("err", error);
  //     })
  //     .finally((final) => {});
  // }
  const formattedList = sangathanList.map((data) => ({
    ...data,
    sangathanName: [
      <Link
        to={`/parent-sangathan-list/${data.parentId}/child-sangathan-list/${data._id}`}
        state={{
          hierarchy: [
            ...(location.state?.hierarchy || []),
            { id: data._id, name: data.name },
          ],
        }}
      >
        {data.name}({data.parentSangathanCount})
      </Link>,
    ],
    Action: [
      <>
        <button
          className="btn btn-primary me-2"
          onClick={() => {
            setShowModal(true);
            onGetChildSangathanList(data._id);
          }}
        >
          <i className="fa fa-eye"></i>
        </button>
        <button
          className="btn btn-secondary me-2"
          onClick={(e) => {
            setEditSangathanModal(true);
            handleEditSangathan(data._id, data.name);
          }}
        >
          <i className="fa fa-edit"></i>
        </button>
        <button
          className="btn btn-primary me-2"
          onClick={(e) => {
            setMoveSangathanModal(true);
            setSourceId(data._id);
            handleMoveSangathan(data._id, data.name);
          }}
        >
          <i className="fa fa-arrows-alt"></i>
        </button>
        {/* {data._id == Values.deleteItemId ? (
              <button
                type="button"
                className="btn btn-danger mr-2"
                onClick={(event) => false}
              >
                Deleting...
              </button>
            ) : (
              <button
                type="button"
                className="btn btn-danger mr-2"
                onClick={(event) => {
                  handleDeleteClick(event, data);
                }}
              >
                Delete
              </button>
            )} */}
      </>,
    ],
  }));

  const tableData = {
    columns: [
      {
        label: "Name",
        field: "sangathanName",
        sort: "asc",
        width: 23,
      },
      {
        label: "Users",
        width: 13,
        sort: "asc",
        field: "userCount",
      },
      {
        label: "Action",
        width: 13,
        sort: "asc",
        field: "Action",
      },
    ],
    rows: formattedList,
  };
  return (
    <React.Fragment>
      {isLoading ? (
        <Spinners />
      ) : (
        <Row>
          <Col xl="12">
            <Card>
              <CardHeader>
                <Row>
                  <Col md="12">
                    <CardTitle className="h4 mb-0">Sangathan List</CardTitle>
                    <nav aria-label="breadcrumb">
                      <ol className="breadcrumb">
                        <li className="breadcrumb-item">
                          <Link to="/sangathan-list">Home</Link>
                        </li>

                        {hierarchy.map((item, i) => {
                          const isLast = i === hierarchy.length - 1;
                          return (
                            <li
                              key={item.id}
                              className={`breadcrumb-item ${isLast ? "active" : ""}`}
                              aria-current={isLast ? "page" : undefined}
                            >
                              {isLast ? (
                                item.name
                              ) : (
                                <Link
                                  to={`/parent-sangathan-list/${item.id}`}
                                  state={{
                                    hierarchy: hierarchy.slice(0, i + 1),
                                  }}
                                >
                                  {item.name}
                                </Link>
                              )}
                            </li>
                          );
                        })}
                      </ol>
                    </nav>
                  </Col>
                </Row>
              </CardHeader>
              <CardBody>
                <div className="d-flex justify-content-end mb-2">
                  <Button
                    onClick={(e) => {
                      setAddSangathanModal(true);
                      onAddSangathan();
                    }}
                    style={{
                      outline: "none",
                      boxShadow: "none",
                      transform: "none",
                    }}
                  >
                    <i className="fa fa-plus"></i> Sangathan
                  </Button>
                </div>
                <div class="row">
                  <MDBDataTable responsive striped bordered data={tableData} />
                </div>
                <div className="row">
                  {editSangathanModal && (
                    <Modal
                      size="m"
                      centered
                      show={editSangathanModal}
                      backdrop="static"
                      keyboard={false}
                      onHide={() => setEditSangathanModal(false)}
                    >
                      <Modal.Header closeButton>
                        <Modal.Title>Update Sangathan Detail</Modal.Title>
                      </Modal.Header>
                      <form onSubmit={handleEditSubmit}>
                        <Modal.Body>
                          <div className="row">
                            <div className="col-md-12">
                              <div className="form-group">
                                <label for="categoryName" class="form-label">
                                  Sangathan Name
                                  <span class="text-danger"> *</span>
                                </label>
                                <Input
                                  classNamePrefix=""
                                  value={sangathanName}
                                  onChange={(e) => {
                                    setSangathanName(e.target.value);
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                        </Modal.Body>
                        <Modal.Footer>
                          <Button variant="primary" type="submit">
                            Save
                          </Button>
                          <Button
                            variant="secondary"
                            onClick={(e) => setEditSangathanModal(false)}
                          >
                            Close
                          </Button>
                        </Modal.Footer>
                      </form>
                    </Modal>
                  )}
                </div>
                <div className="row">
                  {moveSangathanModal && (
                    <Modal
                      size="m"
                      centered
                      show={moveSangathanModal}
                      backdrop="static"
                      keyboard={false}
                      onHide={() => setMoveSangathanModal(false)}
                    >
                      <Modal.Header closeButton>
                        <Modal.Title>Move Sangathan</Modal.Title>
                      </Modal.Header>
                      <form>
                        <Modal.Body>
                          <div className="row">
                            <div className="col-md-12">
                              <div className="form-group">
                                <label for="categoryName" class="form-label">
                                  Sangathan Name
                                  <span class="text-danger"> *</span>
                                </label>
                                <Input
                                  classNamePrefix=""
                                  readOnly="true"
                                  value={sangathanName}
                                  onChange={(e) => {
                                    setSangathanName(e.target.value);
                                  }}
                                />
                              </div>
                            </div>
                            <div className="col-md-12">
                              <div className="form-group">
                                <label for="categoryName" class="form-label">
                                  Move Sangathan
                                  <span class="text-danger"> *</span>
                                </label>
                                <select
                                  value={sangathanId}
                                  className="form-select"
                                  // onChange={(e) =>
                                  //   setSangathanId(e.target.value)
                                  // }
                                  onChange={(e) => {
                                    const selectedName = sangathanList.find(
                                      (item) => item._id === e.target.value
                                    )?.name;

                                    if (selectedName === sangathanName) {
                                      setSameSangathan(true);
                                    } else {
                                      setSameSangathan(false);
                                    }

                                    setSangathanId(e.target.value);
                                  }}
                                >
                                  <option value="">Select Sangathan</option>
                                  {sangathanList.map((item, index) => (
                                    <option
                                      key={index}
                                      value={item._id}
                                      disabled={item.name === sangathanName}
                                    >
                                      {item.name}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>
                          </div>
                        </Modal.Body>
                        <Modal.Footer>
                          <Button
                            variant="primary"
                            type="button"
                            onClick={handleMoveSubmit}
                            disabled={sameSangathan}
                          >
                            Move
                          </Button>
                          <Button
                            variant="secondary"
                            onClick={(e) => setMoveSangathanModal(false)}
                          >
                            Close
                          </Button>
                        </Modal.Footer>
                      </form>
                    </Modal>
                  )}
                </div>
                <div className="row">
                  <Modal
                    size="m"
                    centered
                    show={changeRoleModal}
                    backdrop="static"
                    keyboard={false}
                    onHide={() => setChangeRoleModal(false)}
                  >
                    <Modal.Header closeButton>
                      <Modal.Title>Change Role</Modal.Title>
                    </Modal.Header>
                    <form>
                      <Modal.Body>
                        <div className="mb-3">
                          <div className="form-group">
                            <Label className="form-label">Role Name</Label>
                            <Select
                              classNamePrefix="select2-selection"
                              value={role}
                              onChange={(e) => setRole(e)}
                              options={roleList}
                            />
                          </div>
                        </div>
                      </Modal.Body>
                      <Modal.Footer>
                        <Button
                          variant="secondary"
                          onClick={(e) => setChangeRoleModal(false)}
                        >
                          Close
                        </Button>
                        <Button variant="primary" onClick={handleChangeRole}>
                          Update
                        </Button>
                      </Modal.Footer>
                    </form>
                  </Modal>
                </div>
                <div className="row">
                  {moveSangathanModal && (
                    <Modal
                      size="m"
                      centered
                      show={moveSangathanModal}
                      backdrop="static"
                      keyboard={false}
                      onHide={() => setMoveSangathanModal(false)}
                    >
                      <Modal.Header closeButton>
                        <Modal.Title>Move Sangathan</Modal.Title>
                      </Modal.Header>
                      <form>
                        <Modal.Body>
                          <div className="row">
                            <div className="col-md-12">
                              <div className="form-group">
                                <label for="categoryName" class="form-label">
                                  Sangathan Name
                                  <span class="text-danger"> *</span>
                                </label>
                                <Input
                                  classNamePrefix=""
                                  readOnly="true"
                                  value={sangathanName}
                                  onChange={(e) => {
                                    setSangathanName(e.target.value);
                                  }}
                                />
                              </div>
                            </div>
                            <div className="col-md-12">
                              <div className="form-group">
                                <label for="categoryName" class="form-label">
                                  Which sangathan do you want to move to?
                                  <span class="text-danger"> *</span>
                                </label>
                                <select
                                  value={sangathanId}
                                  className="form-select"
                                  onChange={(e) => {
                                    const selectedName = sangathanList.find(
                                      (item) => item._id === e.target.value
                                    )?.name;

                                    if (selectedName === sangathanName) {
                                      setSameSangathan(true);
                                    } else {
                                      setSameSangathan(false);
                                    }
                                    setTargetName(selectedName);
                                    setTargetId(e.target.value);
                                    setSangathanId(e.target.value);
                                  }}
                                >
                                  <option value="">Select Sangathan</option>
                                  {sangathanList.map((item, index) => (
                                    <option
                                      key={index}
                                      value={item._id}
                                      disabled={item.name === sangathanName}
                                    >
                                      {item.name}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>
                          </div>
                        </Modal.Body>
                        <Modal.Footer>
                          <Button
                            variant="primary"
                            type="button"
                            onClick={handleMoveSubmit}
                            disabled={sameSangathan}
                          >
                            Move
                          </Button>
                          <Button
                            variant="secondary"
                            onClick={(e) => setMoveSangathanModal(false)}
                          >
                            Close
                          </Button>
                        </Modal.Footer>
                      </form>
                    </Modal>
                  )}
                </div>
                <div className="row">
                  <Modal
                    size="xl"
                    centered
                    show={showModal}
                    backdrop="static"
                    keyboard={false}
                    onHide={() => setShowModal(false)}
                  >
                    <Modal.Header closeButton>
                      <Modal.Title>User List</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      <div className="row">
                        <table className="table table-bordered table-striped dataTable">
                          <thead>
                            <tr>
                              <th>#</th>
                              <th>Name</th>
                              <th>Mobile No.</th>
                              <th>Email</th>
                              <th>VUF Id</th>
                              <th>Role</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {sangathanUserList.map((user, item) => (
                              <tr key={user.id}>
                                <td>{item + 1}</td>
                                <td>{user.firstName + "  " + user.lastName}</td>
                                <td>{user.mobileNo ? user.mobileNo : "---"}</td>
                                <td>{user.email ? user.email : "---"}</td>
                                <td>{user.vufId ? user.vufId : "---"}</td>
                                <td>{user.role ? user.role : "---"}</td>
                                <td>
                                  <Button
                                    onClick={(e) => {
                                      ChangeRole(user._id);
                                      setShowModal(false);
                                      setChangeRoleModal(true);
                                      getRolesList();
                                    }}
                                  >
                                    Change Role
                                  </Button>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </Modal.Body>
                    <Modal.Footer>
                      <Button
                        variant="secondary"
                        onClick={() => setShowModal(false)}
                      >
                        Close
                      </Button>
                    </Modal.Footer>
                  </Modal>
                </div>
                <div className="row">
                  {addModal && (
                    <Modal
                      size="m"
                      centered
                      show={addModal}
                      backdrop="static"
                      keyboard={false}
                      onHide={() => setAddSangathanModal(false)}
                    >
                      <Modal.Header closeButton>
                        <Modal.Title>
                          Add Sangathan of {lastRecord.name}
                        </Modal.Title>
                      </Modal.Header>
                      <form onSubmit={handleAddSubmit}>
                        <Modal.Body>
                          <div className="row">
                            <div className="col-md-12">
                              <div className="form-group">
                                <label for="categoryName" class="form-label">
                                  Parent Sangathan Name
                                  <span class="text-danger"> *</span>
                                </label>
                                <Input
                                  classNamePrefix=""
                                  style={{
                                    backgroundColor: "#f3f4f6",
                                    color: "#6b7280",
                                    cursor: "not-allowed",
                                  }}
                                  readOnly
                                  value={sangathanName}
                                  onChange={(e) => {
                                    setSangathanName(e.target.value);
                                  }}
                                />
                              </div>
                            </div>
                            <div className="col-md-12">
                              <div className="form-group">
                                <label for="categoryName" class="form-label">
                                  Sangathan Name
                                  <span class="text-danger"> *</span>
                                </label>
                                <Input
                                  classNamePrefix=""
                                  value={newSangathanName}
                                  onChange={(e) => {
                                    setNewSangathanName(e.target.value);
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                        </Modal.Body>
                        <Modal.Footer>
                          <Button variant="primary" type="submit">
                            Save
                          </Button>
                          <Button
                            variant="secondary"
                            onClick={(e) => setAddSangathanModal(false)}
                          >
                            Close
                          </Button>
                        </Modal.Footer>
                      </form>
                    </Modal>
                  )}
                </div>
                <div className="row">
                  <Modal
                    show={showConfirmModal}
                    onHide={() => setShowConfirmModal(false)}
                    centered
                  >
                    <Modal.Header closeButton>
                      <Modal.Title>Confirm Delete</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      Are you sure you want to delete this item?
                    </Modal.Body>
                    <Modal.Footer>
                      <Button
                        variant="secondary"
                        onClick={() => setShowConfirmModal(false)}
                      >
                        Cancel
                      </Button>
                      <Button variant="danger" onClick={handleMoveSubmit}>
                        Yes, Delete
                      </Button>
                    </Modal.Footer>
                  </Modal>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      )}
    </React.Fragment>
  );
};

export default connect(null, { setBreadcrumbItems })(ChildSangathanList);
